module.exports = __webpack_public_path__ + "img/qqc_xz_jc2x.ba49288e.png";